import Vue from 'vue'
import * as resources from './resources'

export default {
  getExercises () {
    return resources.Exercises.get()
  },
  getExercise (id) {
    return resources.Exercise.get({id: id})
  },
  getTeams () {
    return resources.Teams.get()
  },
  login (username, password) {
    // return auth.login(username, password
    const base64 = btoa(`${username}:${password}`)

    return new Promise((resolve, reject) => {
      Vue.http.get('auth', {
        headers: {
          'Authorization': `Basic ${base64}`
        }
      })
      .then(response => {
        if (!response.ok) {
          reject(response)
        }
        resolve(response)
      })
      .catch(response => {
        reject(response)
      })
    })
  },
  getSurvey (id) {
    // Pre
    const pre = resources.Survey.get({id: id, type: 'pre'})

    // Post
    const post = resources.Survey.get({id: id, type: 'post'})

    // Sharp brains
    const sharpBrains = resources.Survey.get({id: id, type: 'sharp_brains'})

/*
    // Questions
    const questions = resources.Survey.get({id: id})
*/

    return new Promise((resolve, reject) => {
      Promise.all([pre, post, sharpBrains /*, questions */ ]).then(responses => {
        resolve({
          pre: responses[0].data,
          post: responses[1].data,
          sharp_brains: responses[2].data,
          //questions: responses[3].data
        })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js